<template>
  <aside class="sidebar glass-panel" :class="{ 'open': isOpen }">
    <div class="sidebar-header">
      <div class="logo">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 2L2 10.5L9.5 13.5M21 2L13 22L9.5 13.5M21 2L9.5 13.5" stroke="var(--primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h2>Telegram Admin</h2>
      </div>
    </div>
    
    <nav class="sidebar-nav">
      <router-link to="/" class="nav-item" exact-active-class="active">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="icon"><path d="M4 4H10V10H4V4Z" stroke="currentColor" stroke-width="2"/><path d="M14 4H20V10H14V4Z" stroke="currentColor" stroke-width="2"/><path d="M4 14H10V20H4V14Z" stroke="currentColor" stroke-width="2"/><path d="M14 14H20V20H14V14Z" stroke="currentColor" stroke-width="2"/></svg>
        Dashboard
      </router-link>
      
      <router-link to="/announcements" class="nav-item" active-class="active">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="icon"><path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="currentColor" stroke-width="2"/><path d="M16 2V6M8 2V6M3 10H21" stroke="currentColor" stroke-width="2"/></svg>
        E'lonlar (Ads)
      </router-link>
      
      <router-link to="/users" class="nav-item" active-class="active">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="icon"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="currentColor" stroke-width="2"/></svg>
        Foydalanuvchilar
      </router-link>
      
      <router-link to="/broadcast" class="nav-item" active-class="active">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="icon"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2"/><path d="M12 16V12M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        Xabarnoma (Broadcast)
      </router-link>

      <router-link to="/withdrawals" class="nav-item" active-class="active">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line></svg>
        Pul yechishlar
      </router-link>

      <router-link to="/settings" class="nav-item" active-class="active">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="icon" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
        Sozlamalar (Settings)
      </router-link>
    </nav>
    
    <div class="sidebar-footer">
      <button @click="logout" class="nav-item logout-btn">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="icon" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
        Tizimdan chiqish
      </button>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'AppSidebar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    logout() {
      if(confirm('Tizimdan chiqmoqchimisiz?')) {
        localStorage.removeItem('access_token');
        this.$router.push('/login');
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  left: 1rem;
  top: 1rem;
  bottom: 1rem;
  width: 250px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 50;
  border-radius: 20px;
}

.sidebar-header {
  padding: 2rem 1.5rem;
  border-bottom: 1px solid var(--glass-border);
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo h2 {
  font-size: 1.25rem;
  font-weight: 700;
  background: linear-gradient(to right, #fff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem;
  gap: 0.5rem;
  flex: 1;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  color: var(--text-muted);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
}

.nav-item.active {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(139, 92, 246, 0.2));
  color: var(--primary);
  border: 1px solid rgba(59, 130, 246, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.icon {
  flex-shrink: 0;
}

.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid var(--glass-border);
}

.logout-btn {
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #f87171;
  font-family: inherit;
  font-size: 1rem;
}

.logout-btn:hover {
  background: rgba(248, 113, 113, 0.1);
  color: #ef4444;
}

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-120%);
    transition: transform 0.3s ease-in-out;
    width: 260px;
    top: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    border-radius: 0;
    border-right: 1px solid var(--glass-border);
  }
  .sidebar.open {
    transform: translateX(0);
  }
}
</style>
